import { Component, OnInit } from '@angular/core';

import { AdminService } from '../services/admin.service';

import { LayoutService } from '../../shared/services/layout.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { ErrorService } from '../../shared/services/error.service';

@Component({
    selector: 'admin-create-account',
    templateUrl: 'create-account.component.html'
})

export class AdminCreateAccountComponent implements OnInit{

    constructor(
        private _adminService: AdminService,
        private _layoutService: LayoutService,
        private _pageNavigationService: PageNavigationService,
        private _errorService: ErrorService
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('admin-create-account');
        
        this._adminService.resetError();
        this._adminService.resetCreateAccountData();

        this._adminService.loadInternalRoles();
    }

    getInternalRoles(){
        return this._adminService.getInternalRoles();
    }
    
    getCreateAccountData(){
        return this._adminService.getCreateAccountData()
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    isDisableCreateAccount(){
        return this._adminService.isDisableCreateAccount();
    }

    isLoading(){
        return this._adminService.isLoading();
    }

    cancel(){
        let vLink = ['home'];
        this._pageNavigationService.navigate(vLink);
    }

    createAccount(){
        this._adminService.createAccount();
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/admin/components/create-account.component.ts